import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./app-header.css";

export const AppHeaderUI = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation(); // получаем текущий путь
  const pathname = location.pathname;

  useEffect(() => {
    if (pathname !== "/") return;

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 554);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [pathname]);

  let headerClass = "container";
  console.log("test");
  if (pathname === "/") {
    headerClass += isScrolled ? " scrolled" : " transparent";
  } else if (pathname === "/barriers") {
    headerClass += " black";
  } else if (pathname === "/uzip" || pathname === "/catalog" || pathname === "/catalog/") {
    headerClass += " blue";
  }

  return (
    <header
      className={`${headerClass} ${isScrolled ? "scrolled" : ""}`}
    >
      <Link to="/">
        <img
          src={require("../../../images/logo.png")}
          className="logo"
          alt="Логотип"
        />
      </Link>
      <nav>
        <ul className="navigation">
          <li className="list-item">
            <Link to="/catalog" className="link">
              Каталог оборудования
            </Link>
          </li>
          <li className="list-item">
            <Link to="/barriers" className="link">
              Барьеры искрозащиты
            </Link>
          </li>
          <li className="list-item">
            <Link to="/" className="link">
              HART-коммуникатор
            </Link>
          </li>
          <li className="list-item">
            <Link to="/uzip" className="link">
              УЗИП
            </Link>
          </li>
          <li className="list-item">
            <Link to="/" className="link">
              О компании
            </Link>
          </li>
        </ul>
      </nav>
    </header>
  );
};
